class NavAccordionGroup extends HTMLElement {
  constructor () {
    super()

    this.accordions = this.querySelectorAll(
      ':scope > [data-nav-accordion-group-el="accordion"]',
    )

    this.topLevelAccordions = document.querySelectorAll(
      '[data-nav-accordion-group-top-level="true"]',
    )

    if (this.accordions.length !== 0) this.setupListeners()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.accordions.forEach((el) => {
      const trigger = el.querySelector(
        ':scope > [data-nav-accordion-group-el="trigger"]',
      )
      if (!trigger) return
      trigger.addEventListener(`click`, this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const targetAccordion = event.target.closest(
      '[data-nav-accordion-group-el="accordion"]',
    )
    if (!targetAccordion) return

    let accordions = this.accordions

    if (event.target.dataset.navAccordionGroupTriggerTopLevel === 'true') {
      accordions = [...accordions, ...this.topLevelAccordions]
    }

    if (this.dataset.type === 'oneopen') {
      accordions.forEach((accordion) => {
        if (!accordion) return

        if (accordion !== targetAccordion) {
          accordion.setAttribute('aria-expanded', 'false')

          const nestedAccordions = accordion.querySelectorAll(
            '[data-nav-accordion-group-el="accordion"]',
          )

          nestedAccordions.forEach((nestedAccordion) => {
            nestedAccordion.setAttribute('aria-expanded', 'false')
          })
        }
      })
    }

    const currentState =
      targetAccordion.getAttribute('aria-expanded') === 'true'

    if (currentState === true) {
      const nestedAccordions = targetAccordion.querySelectorAll(
        '[data-nav-accordion-group-el="accordion"]',
      )

      nestedAccordions.forEach((nestedAccordion) => {
        nestedAccordion.setAttribute('aria-expanded', 'false')
      })
    }

    targetAccordion.setAttribute('aria-expanded', !currentState)
  }
}

if (!customElements.get('nav-accordion-group')) {
  customElements.define('nav-accordion-group', NavAccordionGroup)
}
